import { useTranslation } from 'react-i18next';
import { RecruiterPanel } from '@/components/RecruiterPanel';

/** /recruitment/earnings — wraps the existing referral/earnings/withdraw panel. */
export function Earnings(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="admin-page">
      <header className="admin-page__header">
        <h1>{t('recruitment.earnings.title')}</h1>
        <p className="muted">{t('recruitment.earnings.intro')}</p>
      </header>
      <RecruiterPanel />
    </main>
  );
}
